import { render, staticRenderFns } from "./InventoryGUI.vue?vue&type=template&id=b997506a&scoped=true&"
import script from "./InventoryGUI.vue?vue&type=script&lang=js&"
export * from "./InventoryGUI.vue?vue&type=script&lang=js&"
import style0 from "./InventoryGUI.vue?vue&type=style&index=0&id=b997506a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b997506a",
  null
  
)

export default component.exports